<div class="login-content">
  <a href="/" class="login-logo">
    <img src="./assets/img/logo.png" alt="Logo" />
  </a>

  <div>Please wait...</div>
</div>
